import { useState, useEffect } from 'react';
import logger from "../../utils/logger";

const DemurrageModal = ({ show, onClose, demurrageData, onSave, theme }) => {
    const [demurrageType, setDemurrageType] = useState('');
    const [reason, setReason] = useState('');
    const [cost, setCost] = useState('');
    const [error, setError] = useState('');
    const isLightTheme = theme === 'light';

    logger.log('Current Demurrage Data:', demurrageData);

    // on mount load states
    useEffect(() => {
        setDemurrageType(demurrageData?.demurrage || '');
        setReason(demurrageData?.demurrage_reason || '');
        setCost((demurrageData?.demurrage_cost !== undefined && demurrageData?.demurrage_cost !== null && demurrageData?.demurrage_cost !== '') ? demurrageData.demurrage_cost : '');
    }, [demurrageData]);

    const handleSave = () => {
        // Validate inputs
        if (!demurrageType) {
            setError('Please select a demurrage type');
            return;
        }

        if (!reason.trim()) {
            setError('Please provide a reason for demurrage');
            return;
        }

        if (!cost) {
            setError('Please enter a cost');
            return;
        }

        // validate cost (0.00)
        const costPattern = /^\d+\.\d{2}$/;
        if (!costPattern.test(cost)) {
            setError('Cost must be in format 0.00');
            return;
        }

        setError('');
        onSave({ 
            ...demurrageData, 
            demurrage: demurrageType, 
            demurrage_reason: reason,
            demurrage_cost: parseFloat(cost)
        });
    };

    const handleClose = () => {
        setError('');
        onClose();
    };

    if (!show) return null;

    const demurrageOptions = [
        'Delay at collection',
        'Delay at delivery', 
        'Cancellation'
    ];

    return (
        <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{
                background: isLightTheme ? '#fff' : '#222',
                color: isLightTheme ? '#222' : '#fff',
                borderRadius: 10,
                border: !isLightTheme ? '2px solid #ddd' : '1px solid #444',
                padding: 30,
                minWidth: 400,
                boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                minHeight: 350
            }}>
                {/* Close button */}
                <button 
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: 10,
                        right: 15,
                        background: 'transparent',
                        border: 'none',
                        fontSize: 24,
                        cursor: 'pointer',
                        color: isLightTheme ? '#999' : '#ccc'
                    }}
                >
                    ×
                </button>

                <h3 style={{ marginBottom: 25, fontSize: 20, fontWeight: 'bold' }}>
                    Add Demurrage
                </h3>

                {/* Demurrage Type Dropdown */}
                <div style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}>
                        Demurrage Type:
                    </label>
                    <select
                        value={demurrageType}
                        onChange={(e) => setDemurrageType(e.target.value)}
                        style={{
                            width: '100%',
                            padding: 10,
                            borderRadius: 5,
                            border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
                            background: isLightTheme ? '#fff' : '#333',
                            color: isLightTheme ? '#222' : '#fff',
                            fontSize: 14
                        }}
                    >
                        <option value="">Select demurrage type...</option>
                        {demurrageOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </div>

                {/* Reason Textarea */}
                <div style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}>
                        Reason:
                    </label>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Enter detailed reason for demurrage..."
                        style={{
                            width: '100%',
                            padding: 10,
                            borderRadius: 5,
                            border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
                            background: isLightTheme ? '#fff' : '#333',
                            color: isLightTheme ? '#222' : '#fff',
                            fontSize: 14,
                            minHeight: 80,
                            resize: 'vertical'
                        }}
                    />
                </div>

                {/* Cost Input */}
                <div style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}>
                        Cost (£):
                    </label>
                    <input
                        type="text"
                        value={cost}
                        onChange={(e) => setCost(e.target.value)}
                        placeholder="0.00"
                        style={{
                            width: '100%',
                            padding: 10,
                            borderRadius: 5,
                            border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
                            background: isLightTheme ? '#fff' : '#333',
                            color: isLightTheme ? '#222' : '#fff',
                            fontSize: 14
                        }}
                    />
                </div>

                {/* Error Message */}
                {error && (
                    <div style={{
                        color: '#e74c3c',
                        fontSize: 12,
                        marginBottom: 15,
                        padding: 8,
                        background: 'rgba(231, 76, 60, 0.1)',
                        borderRadius: 4,
                        border: '1px solid rgba(231, 76, 60, 0.2)'
                    }}>
                        {error}
                    </div>
                )}

                {/* Action Buttons */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 'auto' }}>
                    <button
                        onClick={handleClose}
                        style={{
                            padding: '10px 20px',
                            borderRadius: 5,
                            border: `1px solid ${isLightTheme ? '#ddd' : '#555'}`,
                            background: 'transparent',
                            color: isLightTheme ? '#666' : '#ccc',
                            cursor: 'pointer',
                            fontSize: 14
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        style={{
                            padding: '10px 20px',
                            borderRadius: 5,
                            border: 'none',
                            background: '#28a745',
                            color: '#fff',
                            cursor: 'pointer',
                            fontSize: 14,
                            fontWeight: 500
                        }}
                    >
                        Save Demurrage
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DemurrageModal;